import type { TOC } from '@ember/component/template-only';
import { PrismCard, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsTaxesController from 'lumen/controllers/hotel/settings/taxes';

interface HotelSettingsTaxesSignature {
  Args: {
    controller: HotelSettingsTaxesController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.rates.description"}}
    @hasAccountSelector={{true}}
    @title={{t "general.taxes"}}
    @type="container"
  >
    <PrismCard>
      <:content>
        <div class="mt-400 flex flex-col gap-400">
          <div class="flex flex-col gap-50">
            <p class="text-300--regular">
              <span class="text-300--bold">{{t "settings.rates.vat"}}:</span>
              {{@controller.taxes.VAT}}
            </p>
            <p class="text-300--regular">
              <span class="text-300--bold">{{t
                  "settings.rates.city_tax"
                }}:</span>
              {{@controller.taxes.cityTax}}
            </p>
            <p class="text-300--regular">
              <span class="text-300--bold">{{t
                  "settings.rates.other_taxes"
                }}:</span>
              {{@controller.taxes.otherTaxes}}
            </p>
          </div>
          <a
            class="prism-link prism-link--medium prism-link--standalone flex gap-100"
            href="https://help.mylighthouse.com/en/articles/3207122-how-do-we-deal-with-taxes"
            rel="noopener noreferrer"
            target="_blank"
          >
            <PrismIcon @color="inherit" @name="book" @size="small" />
            {{t "settings.rates.how_to_manage_taxes"}}
          </a>
        </div>

      </:content>
    </PrismCard>

  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsTaxesSignature>;
